import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "../../../components/FormControl";
import Select from "@mui/material/Select";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import { TextField, Typography } from "@mui/material";

export default function AddQuestionBankDialog({
  editDialogOpen,
  handleDialogClose,
  ...props
}) {
  const [isSaving, setIsSaving] = useState(false);
  const [questionString, setQuestionString] = useState("");

  const changeQuestionString = (e) => {
    setQuestionString(e);
  };

  const onSubmit = async () => {
    if (!questionString.length > 0) {
      toast.error("Please fill required fields", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setIsSaving(true);

    let data = {
      questionBankId: 0,
      questionReference: 2,
      questionReferenceId: 0,
      questionString: questionString,
      questionStatus: 1,
      usedFor: 0,
    };

    const resp = await axios.post(
      BaseURL.templateTool.AddQuestionInQuestionBank,
      data
    );
    console.log(resp);
    if (resp.data?.responseCode == 100) {
      const questionBankId = resp.data.data;
      if (questionBankId > 0) {
        data.questionBankId = questionBankId;
        handleDialogClose(data);
      }
      setIsSaving(false);

      toast.success(resp.data?.responseMessage, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setIsSaving(false);

      console.error(resp?.data?.responseMessage);
      toast.error(resp.data?.responseMessage, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <>
      {" "}
      <Dialog open={true} onClose={handleDialogClose} className="w-100 p-2">
        <DialogTitle id="addQuestionBank-dialog-title">
          {"Add Question"}
        </DialogTitle>
        <DialogContent sx={{ m: 2, width: 450 }}>
          <DialogContentText id="addQuestionBank-dialog-description">
            <div className="row mt-2">
              <div className="col-sm-12 mt-1">
                <span className="input-label-right ms-2">
                  Title
                  <small style={{ color: "red" }}>*</small>
                </span>
              </div>
              <div className="col-sm-12 mt-1">
                <TextField
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  size="small"
                  required
                  id="questionString"
                  name="questionString"
                  value={questionString || ""}
                  className="form-control text-feild-custom mx-2"
                  onChange={(e) => changeQuestionString(e.target.value)}
                />
              </div>
              <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="login-help__buttonContainer d-flex gap-2 align-items-center px-5">
            <Button
              className="login-help-button-cancel mx-2"
              variant="contained"
              onClick={handleDialogClose}
            >
              Cancel
            </Button>
            {isSaving ? (
              <Box
                style={{
                  display: "flex",
                  marginLeft: "auto",
                  padding: "5px",
                }}
              >
                <CircularProgress size={28} />
              </Box>
            ) : (
              <Button
                variant="contained"
                onClick={onSubmit}
                className="login-button-request mx-2"
              >
                Add
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
}
